// import React from 'react';
// import "../../Styles/Footer.scss";
// // import footerLogo from "../../Assests/Footer/footer-vizzhyLogo.svg";
// // import google from '../../Assests/Footer/google-play.svg';
// // import appstore from '../../Assests/Footer/app-store.svg';
// import insta from '../../Assests/Footer/insta-image.svg';
// // import facebook from '../../Assests/Footer/facebook-image.svg';
// import linkedIn from '../../Assests/Footer/linkedin-image.svg';
// // import youtube from '../../Assests/Footer/yt-image.svg';
// import twitter from '../../Assests/Footer/twitter-image.svg';
// import footer from '../../Assests/Footer/footer-vizzhy.svg';
// import { Link, useNavigate } from 'react-router-dom';

// function Footer() {
//   const navigate = useNavigate();

//   const handleClick = () => {
//     navigate('/contact');
//   };
//   const handleOnclick = () =>{
//     navigate('/PrivacyPolicy');
//   }
//   return (
//     <>
//       <div className="footer  ">
//         <div className="row text-white pt-5  mx-md-5 mx-0">
//           <div className="col-md-5 text-start">
//             <div>
//               <img className='footer-vizzhy-img' src={footer} alt="footer" />
//             </div>
//             <div className="footer-text-our w-50 mt-3">
//               Our commitment to ethical data use and sustainable practices drives every innovation we bring to healthcare.
//             </div>
//             <div className="mt-3  d-flex justify-content-start align-items-center pt-3" onClick={handleClick}>
//               <button className="btn fw-bold btn-custom d-flex align-items-center contact-us justify-content-center">
//                 Contact Us
//                 <span class="material-symbols-outlined fw-bold ms-2 d-flex align-items-center justify-content-center">
//                   arrow_forward
//                 </span>
//               </button>
//             </div>

//           </div>

//           <div className='col-md-7 d-flex justify-content-between'>
//             <div className=" text-start footer-text mt-4 ">

//               <Link to="/about-us" className='forgot-link text-light'><div>About us</div></Link>

//               <Link to="/our-approach" className='forgot-link text-light'><div className="mt-2">Our Approach</div></Link>
//               <Link to="/team" className='forgot-link text-light'><div className="mt-2">Team</div></Link>
//               {/* <Link to="/news" className='forgot-link text-light'><div className="mt-2">News</div></Link> */}
//               <Link to="/careers" className='forgot-link text-light'><div className="mt-2">Career</div></Link>
//             </div>

//             <div className=" text-start footer-text  mt-4 ">
//               <div>FAQ</div>
//               <div className="mt-2">Product</div>
//               <div className="mt-2 cursor-pointer" onClick={handleOnclick}>Privacy Policy</div>
//               <div className="mt-2">Terms & conditions</div>
//             </div>

//             <div className=" text-center footer-text mt-4">
//               {/* <div className='' >support@vizzhy.com</div> */}
//               {/* <div className="mt-2" style={{ fontSize: "10px" }}>
//                 <img src={google} alt="footerLogo" />
//               </div>
//               <div className="mt-2">
//                 <img src={appstore} alt="footerLogo" />
//               </div> */}
//               <div>
//                 <a href="mailto:support@vizzhy.com  " style={{ color: "white", textDecoration: "none" }}>
//                   support@vizzhy.com
//                 </a>
//               </div>


//             </div>
//           </div>

//         </div>

//         <div className="hr-tag-footer mt-5">
//           <hr className="hr-solid-tag" />
//         </div>

//         <div className="text-white d-flex justify-content-between mt-4 mt-md-4 mt-lg-5 row">
//           <div className="col-md-4 footer-text-our text-start">
//             © 2025 Vizzhy Inc. All rights reserved.
//           </div>
//           <div className="col-md-2 d-flex justify-content-between logos-footer">

//             <div className="cursor-pointer">
//               <a href="https://www.linkedin.com/company/vizzhy/" target="_blank" rel="noopener noreferrer">
//                 <img src={linkedIn} alt="LinkedIn" />
//               </a>
//             </div>
//             <div className="cursor-pointer">
//               <a href="https://x.com/vizzhy_health?lang=en" target="_blank" rel="noopener noreferrer">
//                 <img src={twitter} alt="Twitter" />
//               </a>

//             </div>
//             <div className="cursor-pointer">
//               <a href="https://www.instagram.com/vizzhy_healthcare/" target="_blank" rel="noopener noreferrer">
//                 <img src={insta} alt="Instagram" />
//               </a>
//             </div>
//             {/* <div className="">
//               <img src={facebook} alt="Facebook" />
//             </div>
//             <div className="">
//               <img src={youtube} alt="YouTube" />
//             </div> */}

//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default Footer;



import React from 'react';
import "../../Styles/Footer.scss";
// import footerLogo from "../../Assests/Footer/footer-vizzhyLogo.svg";
// import google from '../../Assests/Footer/google-play.svg';
// import appstore from '../../Assests/Footer/app-store.svg';
import insta from '../../Assests/Footer/insta-image.svg';
// import facebook from '../../Assests/Footer/facebook-image.svg';
import linkedIn from '../../Assests/Footer/linkedin-image.svg';
// import youtube from '../../Assests/Footer/yt-image.svg';
import twitter from '../../Assests/Footer/twitter-image.svg';
import footer from '../../Assests/Footer/footer-vizzhy.svg';
import { Link, useNavigate } from 'react-router-dom';

function Footer() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/contact');
  };
  return (
    <>
      <div className="footer  ">
        <div className="row text-white pt-5  mx-md-5 mx-0">
          <div className="col-md-5 text-start">
            <div>
              <img className='footer-vizzhy-img' src={footer} alt="footer" />
            </div>
            <div className="footer-text-our w-50 mt-3">
              Our commitment to ethical data use and sustainable practices drives every innovation we bring to healthcare.
            </div>
            <div className="mt-3  d-flex justify-content-start align-items-center pt-3" onClick={handleClick}>
              <button className="btn fw-bold btn-custom d-flex align-items-center contact-us justify-content-center">
                Contact Us
                <span class="material-symbols-outlined fw-bold ms-2 d-flex align-items-center justify-content-center">
                  arrow_forward
                </span>
              </button>
            </div>

          </div>

          <div className='col-md-7 d-flex justify-content-between'>
            <div className=" text-start footer-text mt-4 ">

              <Link to="/about-us" className='forgot-link text-light'><div>About us</div></Link>

              <Link to="/our-approach" className='forgot-link text-light'><div className="mt-2">Our Approach</div></Link>
              <Link to="/team" className='forgot-link text-light'><div className="mt-2">Team</div></Link>
              {/* <Link to="/news" className='forgot-link text-light'><div className="mt-2">News</div></Link> */}
              <Link to="/careers" className='forgot-link text-light'><div className="mt-2">Careers</div></Link>
            </div>

            <div className=" text-start footer-text  mt-4 ">
              <Link to="/contact" className='forgot-link text-light' state={{ scrollToFAQ: true }}>
                <div>FAQ</div>
              </Link>

              <Link to="/products" className='forgot-link text-light'><div className="mt-2">Products</div></Link>
              <Link to="/PrivacyPolicy" className='forgot-link text-light'><div className="mt-2">Privacy Policy</div></Link>
              <div className="mt-2"></div>
              {/* <div className="mt-2"></div> */}
              <Link to="/TermsConditions" className='forgot-link text-light'><div className="mt-2">Terms & conditions</div></Link>

            </div>

            <div className=" text-center footer-text mt-4">
              {/* <div className='' >support@vizzhy.com</div> */}
              {/* <div className="mt-2" style={{ fontSize: "10px" }}>
                <img src={google} alt="footerLogo" />
              </div>
              <div className="mt-2">
                <img src={appstore} alt="footerLogo" />
              </div> */}
              <div>
                <a href="mailto:support@vizzhy.com  " style={{ color: "white", textDecoration: "none" }}>
                  support@vizzhy.com
                </a>
              </div>


            </div>
          </div>

        </div>

        <div className="hr-tag-footer mt-5">
          <hr className="hr-solid-tag" />
        </div>

        <div className="text-white d-flex justify-content-between mt-4 mt-md-4 mt-lg-5 row">
          <div className="col-md-4 footer-text-our text-start">
            © 2025 Vizzhy Inc. All rights reserved.
          </div>
          <div className="col-md-2 d-flex justify-content-between logos-footer">

            <div className="cursor-pointer">
              <a href="https://www.linkedin.com/company/vizzhy/" target="_blank" rel="noopener noreferrer">
                <img src={linkedIn} alt="LinkedIn" />
              </a>
            </div>
            <div className="cursor-pointer">
              <a href="https://x.com/vizzhy_health?lang=en" target="_blank" rel="noopener noreferrer">
                <img src={twitter} alt="Twitter" />
              </a>

            </div>
            <div className="cursor-pointer">
              <a href="https://www.instagram.com/vizzhy_healthcare/" target="_blank" rel="noopener noreferrer">
                <img src={insta} alt="Instagram" />
              </a>
            </div>
            {/* <div className="">
              <img src={facebook} alt="Facebook" />
            </div>
            <div className="">
              <img src={youtube} alt="YouTube" />
            </div> */}

          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;